<template>
  <div class="prime-modal">
    <ion-header>
      <ion-toolbar>
        <h3 slot="start" class="text-bold">Canceled Event</h3>
        <ion-button slot="end" mode="ios" @click="closeModal()" expand="full" color="medium" fill="clear"><ion-icon name="md-close"></ion-icon></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content class="prime-modal-content">
      <ion-row class="pad-top-twenty">
        <ion-col>
          <div class="text-bold text-muted">
            Date Canceled
          </div>
          <p class="text-bold">{{ formatEpochDate(eventData.cancelledAt) }}</p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="margin-top-ten">
          <div class="text-bold text-muted">
            Canceled By
          </div>
          <p class="text-bold">{{ makeProfessionalName(eventData) }}</p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="margin-top-ten">
          <div class="text-bold text-muted">
            Reason Provided
          </div>
          <p>{{ eventData.cancelledReason }}</p>
        </ion-col>
      </ion-row>
    </ion-content>
    <ion-footer>
      <ion-grid>
        <ion-row class="ion-align-items-center pad-lr-twenty pad-top-ten pad-bottom-ten">
          <ion-col>
            <button @click="closeModal()" class="prime-button button-secondary button-block">
              Close
            </button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-footer>
  </div>
</template>

<script>
export default {
  name: "ModalEventDescription",
  methods: {
    formatEpochDate(epDate) {
      let date = new Date(Number(epDate));
      return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    },
    closeModal: function() {
      this.$ionic.modalController.dismiss({ description: null });
    },
    makeProfessionalName(rowObj) {
      let title = rowObj.createdByTitle;
      let fName = rowObj.createdByFirstName;
      let lName = rowObj.createdByLastName;
      return (fName ? fName : "") + (lName ? " " + lName : "") + (title ? ", " + title : "");
    }
  }
};
</script>

<style scoped>
ion-textarea {
  background: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 8px;
  padding: 12px 15px;
  font-size: 14px;
  font-family: var(--ion-font-family);
  font-weight: 500;
  line-height: 1.5;
  transition: border 0.2s ease-in-out;
}
ion-textarea textarea {
  padding: 0 !important;
}
ion-textarea:hover {
  background: var(--ion-color-light);
}
ion-textarea:focus {
  background: #ffffff;
  border: 2px solid var(--ion-color-primary);
}

ion-footer {
  padding: 20px;
}
ion-footer ion-col:first-child {
  padding-right: 5px;
}
ion-footer ion-col:not(:first-child) {
  padding-left: 5px;
}
.column-stretch-wrap {
  display: flex;
  flex-direction: column;
}

.column-stretch-header {
  flex: 0 0 auto;
}

.column-stretch-body {
  flex: 1 1 auto;
  position: relative; /* need this to position inner content */
  overflow: hidden;
}

.column-stretch-footer {
  flex: 0 0 auto;
}

.pad-lr-five {
  padding-right: 5px;
  padding-left: 5px;
}
</style>
